import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { BankAccountRouter } from './bank-account/_router'
import { CreditCardRouter } from './credit-card/_router'
import { DomiciliationRouter } from './domiciliation/_router'

const Index = lazy(() => import('./Index'))

export const PaymentMeanRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment-mean']}>
    <Route index element={<Index />} />
    <Route path='bank-account/*' element={<BankAccountRouter />} />
    <Route path='credit-card/*' element={<CreditCardRouter />} />
    <Route path='domiciliation/*' element={<DomiciliationRouter />} />
  </SubRouter>
))
